
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSortGoogle as ObiSortGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sort-google.js';
 
 
 

 
 export const ObiSortGoogle = createComponent({
   react: React,
   tagName: 'obi-sort-google',
   elementClass: ObiSortGoogleElement,
   events: {
     
   }
  });
 
 